import { useTranslation } from 'react-i18next';
import { APP_LOCALES, type AppLocale } from '@/shared/format/locale-data';
import { useLocale } from '@/i18n/useLocale';
import s from '../layouts/Layout.module.css';

/** Переключатель языка RU/KK (ТЗ 14.1, принцип 6): оба языка равноправны, выбор запоминается. */
export function LanguageSwitch() {
  const { t, i18n } = useTranslation('shell');
  const locale = useLocale();
  return (
    <div className={s.language} role="group" aria-label={t('language.label')}>
      {APP_LOCALES.map((option: AppLocale) => (
        <button
          key={option}
          type="button"
          lang={option}
          className={s.languageButton}
          aria-pressed={locale === option}
          aria-label={t(`language.${option}.name`)}
          onClick={() => void i18n.changeLanguage(option)}
        >
          {t(`language.${option}.short`)}
        </button>
      ))}
    </div>
  );
}
